/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamStudentSupervisorFaceResponse } from './oralExamStudentSupervisorFaceResponse';
import type { OralExamStudentSupervisorViewResponseVisitor } from './oralExamStudentSupervisorViewResponseVisitor';

/**
 * Server-built student supervisor disclosure — faces at rest, visitor on Appear/Engage.
 */
export interface OralExamStudentSupervisorViewResponse {
  faces?: OralExamStudentSupervisorFaceResponse[];
  visitor?: OralExamStudentSupervisorViewResponseVisitor;
}
